import {createLazyFileRoute} from '@tanstack/react-router'

import FlightDetails from '@/views/Flight/FlightDetails'

export const Route = createLazyFileRoute('/_flight/flights/$flightId/')({
  component: FlightDetails,
})
